<template>
  <div>
    <div class="mx-2 ustify-center">
      <v-card class="mx-auto my-12" max-width="500">
        <v-img
          class="mx-auto my-12"
          height="150"
          width="150"
          src="@/assets/erroricon.png"
        >
        </v-img>
        <v-card-title class="justify-center">فشل في عملية الدفع</v-card-title>
        <v-card-text>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>رقم العملية</v-list-item-title>
              <v-list-item-subtitle
                v-html="checkoutOrder.id"
              ></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>التاريخ و الوقت</v-list-item-title>
              <v-list-item-subtitle
                v-html="checkoutOrder.completedDate"
              ></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
         <v-list-item>
            <v-list-item-content>
              <v-list-item-title>المجموع(دك)</v-list-item-title>
              <v-list-item-subtitle
               v-html="checkoutOrder.total"
              ></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Payment Id</v-list-item-title>
              <v-list-item-subtitle
                v-html="checkoutOrder.paymentId"
              ></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Transaction Id</v-list-item-title>
              <v-list-item-subtitle
                v-html="checkoutOrder.transactionId"
              ></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

        <!--   <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Knet Post Date</v-list-item-title>
              <v-list-item-subtitle
                v-html="checkoutOrder.postDate"
              ></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item> -->
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CheckoutFailed",

  //********************** */
  props: {

  },

  //********************** */
  components: {},

  //********************** */
  data: () => ({
    isLoading: false,
  }),

  //********************** */
  computed: {
    ...mapGetters("Order", {
      checkoutOrder: "checkoutOrder",
    }),
  },

  //********************** */
  methods: {
    loadOrderInfo: async function () {
       const orderNumber = this.$route.query.number;
      const paymentId = this.$route.query.paymentId;
      const transactionId = this.$route.query.transactionId;

      this.isLoading = true;
      try {
        await this.$store.dispatch("Order/loadCheckoutOrderByPaymentInfo", {orderNumber, paymentId, transactionId});
        this.isLoading = false;
      } catch (error) {
        alert(error);
        this.isLoading = false;
      }
    },
  },

  //*********************** */
  async mounted() {
    await this.loadOrderInfo();
  },
};
</script>

<style>
</style>